import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearPopup } from "../store/popupSlice";

export function Popup({ className }) {
  const dispatch = useDispatch();
  const { message, visible, type } = useSelector((state) => state.popup);
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (!visible) return;

    // Reset progress whenever a new message appears
    setProgress(100);

    const totalDuration = 6000;
    const interval = 100;
    let elapsed = 0;

    const timer = setInterval(() => {
      elapsed += interval;
      const newProgress = Math.max(
        0,
        ((totalDuration - elapsed) / totalDuration) * 100
      );
      setProgress(newProgress);

      if (elapsed >= totalDuration) {
        clearInterval(timer);
        dispatch(clearPopup());
      }
    }, interval);

    // Cleanup on unmount or when message changes
    return () => clearInterval(timer);
  }, [message, visible, dispatch]); // <-- dependency on message too

  if (!visible) return null;

  const defaultClass =
    type === "success"
      ? "fixed top-20 left-1/2 transform -translate-x-1/2 bg-green-600 text-white p-4 rounded shadow-lg z-50 min-w-[300px] max-w-md"
      : "fixed top-20 left-1/2 transform -translate-x-1/2 bg-red-600 text-white p-4 rounded shadow-lg z-50 min-w-[300px] max-w-md";

  return (
    <div className={className ? className : defaultClass}>
      <div className="flex justify-between items-center">
        <span>{message}</span>
        <button
          onClick={() => dispatch(clearPopup())}
          className="text-white font-bold ml-4"
        >
          &times;
        </button>
      </div>

      <div
        className={`mt-2 w-full h-1 rounded ${
          type === "success" ? "bg-green-800" : "bg-red-800"
        }`}
      >
        <div
          className={`h-1 rounded ${
            type === "success" ? "bg-green-100" : "bg-red-100"
          }`}
          style={{ width: `${progress}%`, transition: "width 0.1s linear" }}
        />
      </div>
    </div>
  );
}
